import React, {useState} from 'react';
import {Link} from "react-router-dom";

import CountryFlagAndName from './countryFlagAndName.js'
import DomainReference from './domainReference.js'
import ListButton from './listButton.js'
import Pagination from './pagination.js'
import SectionHeader from './sectionHeader.js'
import UserError from './userError.js';
import Login from '../pages/Login/index.js'
import {useLogin} from '../helpers/loginContext.js'

import {useAuth} from '../helpers/authContext.js'

import {_printDomainRank} from '../helpers/helpers.js'
import {TechnologyDomains, Domain} from '../../../server/routes/route-types.js'


interface DomainRowProps {
   domain: Domain;
   requireAuthentication?: boolean;
}

export default function DomainTable({domainList,link}: {domainList: TechnologyDomains, link?: string}) {

	return (
		<>
			{
			domainList &&
			<div className="row row-50">
				<div className="col-12">
					<SectionHeader 
						header={domainList.Header}
						link={link} 
						anchor='domains'
					/>
					{
						domainList.ShowTopButton &&
							<>
								<Link
									className="button button-secondary"
									title={domainList.Button!.Title}
									rel="noopener nofollow noreferrer"
									to={domainList.Button!.Href}
								>
									{domainList.Button!.Text}
								</Link>
								<br />
						{/*		Flat price per the report, subscription is not required.
								<br />
								<br />*/}
							</>
					}
					<UserError message={domainList.Message}/>
					<UserError message={domainList.UserError}/>
					<DomainTableSimple domainList={domainList} />
					<Pagination pages={domainList.Pages} />
					{
						!domainList.ShowTopButton && domainList.Button &&
						<ListButton button={{...domainList.Button, IsDomainList: true}} />
					}
                </div>
			</div>
		}
		</>
	)
}

/*
function UserError({message}) {

	if (!message) {
		return null;
	}

	return (
		<><br />
			<div className="alert alert-warning alert-dismissible fade show" role="alert">
				<div dangerouslySetInnerHTML={{__html: message}}/>
				<button type="button" className="close" data-dismiss="alert" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			</>
		)
}
*/

function DomainTableSimple({domainList}: {domainList: TechnologyDomains}) {
	if (!domainList) return (<></>);
	if (!domainList.Domains) return (<></>);

	if (domainList.NoDomainsError)
		return (<NoDomainsError domainList={domainList}/>)
	else
		return (<DomainTableSimpleImpl domainList={domainList}/>)
}

function NoDomainsError({domainList}: {domainList: TechnologyDomains}) {
	if (!domainList.NoDomainsError) return <></>;
	return (
		<div className="alert alert-warning alert-dismissible fade show" role="alert">
			<div dangerouslySetInnerHTML={{__html: domainList.NoDomainsError}}/>
			<button type="button" className="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	)
}

function DomainTableSimpleImpl({domainList}: {domainList: TechnologyDomains}) {
	if (!domainList.Domains) return (<></>);
	return (
		<>
			<div className="table-outer table-rounded table-responsive-lg">
			<table className="table-custom table-custom-striped table-custom-primary  ">
				<thead>
				<tr>
					<th style={{width: '40%'}}>Domain</th>
					<th style={{width: '30%'}}>Country</th>
					<th style={{width: '15%'}}>Rank</th>
					<th style={{width: '15%'}}>Contacts</th>
				</tr>
				</thead>
					<tbody>
						{
						domainList.Domains.map((domain, indexKey) => {
							return (
								<DomainRow domain={domain} key={indexKey} requireAuthentication={domainList.RequireAuthentication}/>
							)
						})
					}
				</tbody>
			</table>
			</div>

		</>
	)
}

function DomainRow({domain, requireAuthentication}: DomainRowProps) {

	const {setLoginType} = useLogin();

	return (

		<>
			<tr>
				<td>
					{
						requireAuthentication &&
							<>
								<a
									href="#"
									style={{padding: '0px', fontSize: '10px'}}
									className="btn btn-primary"
									onClick={(e) => {
										e.preventDefault();
										setLoginType((<Login />))
									}}
										
								>
									Login to view
								</a>
								{'  '}
							</>
					}
					{
						!domain.Hidden ?
							<DomainReference
								domain={domain.Domain}
								openProtocol={domain.OpenProtocol}
								title={`${domain.Domain} information and technology stack`}
							/>:
							<HiddenDomain domain={domain.Domain}/>
					}
				</td>
				<td>
					<CountryFlagAndName countryCode={domain.Country} />
				</td>
				<td>
					{_printDomainRank(domain.Rank, domain.Hidden!)}
				</td>
				{
					domain.Contacts &&
					<>
						<td style={{color:'rgb(22, 182, 210)'}}>
						{
							undefined != domain.Contacts.Facebook &&
								<i title = "Facebook account" className="fab fa-facebook-f"> </i>
						}
						{
							undefined != domain.Contacts.Twitter &&
								<i title = "Twitter account" className="fab fa-twitter"> </i>
						}
						{
							undefined != domain.Contacts.Email &&
								<i title = "Email" className="fab fa-envelope"> </i>
						}
						{
							undefined != domain.Contacts.Phone &&
								<i title = "Contact phone number" className="fab fa-phone"> </i>
						}
						{
							undefined != domain.Contacts.Instagram &&
								<i title = "Instagram account" className="fab fa-instagram"> </i>
						}
						{
							undefined != domain.Contacts.Youtube &&
								<i title = "Youtube channel" className="fab fa-youtube"> </i>
						}
						{
							undefined != domain.Contacts.Linkedin &&
								<i title = "LinkedIn account" className="fab fa-linkedin"> </i>
						}
						{
							undefined != domain.Contacts.Address &&
								<i title = "Address on file" className="fab fa-address-card"> </i>
						}
						</td>
					</>
				}
			</tr>
		</>
	)
}

function HiddenDomain({domain}: {domain: string}) {
	return (
		<>
			{` ${domain} `}
		</>
	)
}